import React, { ReactNode } from "react";

import "./LinkButton.scss";

interface LinkButtonProps extends React.PropsWithChildren<any> {
  nocolor?: boolean;
  title?: string;
  onClick?: Function;
  children?: ReactNode;
  disabled?: boolean;
}

/**
 * This is a Button that looks like a link (nothing to do with react-router Link).
 */
const LinkButton = (props: LinkButtonProps) => {
  return (
    <button
      className={[
        "LinkButton",
        props.nocolor ? "" : "LinkButton__Color",
        props.className || "",
      ].join(" ")}
      onClick={(e) => {
        if (props.onClick) {
          props.onClick(e);
        }
      }}
      title={props.title}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
};

export default LinkButton;
